import images from "../../assets/images/assets";
import Title from "../SmallComponents/Title";
import CartTotal from "./CartTotal";

import { useContext, useEffect, useState } from "react";
import { ShopContext } from "../Context/ShopContext";

const CartSection = () => {
  const {
    products,
    currency,
    cartItems,
    updateQuantity,
    navigate,
    token,
    getUserCart,
  } = useContext(ShopContext);

  const [cartData, setCartData] = useState([]);

  useEffect(() => {
    if (token) {
      getUserCart(token); // Call getUserCart here
    }
  }, [token, getUserCart]);

  useEffect(() => {
    if (products.length > 0) {
      const tempData = [];
      for (const items in cartItems) {
        for (const item in cartItems[items]) {
          if (cartItems[items][item] > 0) {
            tempData.push({
              _id: items,
              size: item,
              quantity: cartItems[items][item],
            });
          }
        }
      }
      setCartData(tempData);
    }
  }, [cartItems, products]);

  return (
    <div className="pt-14">
      <div className="text-2xl mb-3">
        <Title text1={"Your"} text2={"Cart"} />
      </div>

      <div className="">
        {cartData.map((item, index) => {
          const productData = products.find(
            (products) => products._id === item._id
          );

          return (
            <div
              key={index}
              className="py-4 border-t text-gray-700 grid-cols-[4fr_0.5fr_0.5fr] sm:grid-cols-[4fr_2fr_0.5fr] items-center gap-4 "
            >
              <div className="flex items-center justify-between">
                <div className="flex items-start gap-6">
                  <img
                    className="w-16 sm:w-20"
                    src={productData.images[0]}
                    alt="image"
                  />
                  <div>
                    <p className="text-xs sm:text-lg font-medium">
                      {productData.name}
                    </p>
                    <div className="flex items-center gap-5 mt-2">
                      <p>
                        {currency} {productData.price}
                      </p>
                      <p className="px-2 sm:px-3 sm:py-1 border bg-slate-50">
                        {item.size}
                      </p>
                    </div>
                  </div>
                </div>
                <input
                  onChange={(e) =>
                    e.target.value === "" || e.target.value === "0"
                      ? null
                      : updateQuantity(
                          item._id,
                          item.size,
                          Number(e.target.value)
                        )
                  }
                  className="border max-w-10 sm:max-w-20 px-1 sm:px-2 py-1"
                  type="number"
                  min={1}
                  defaultValue={item.quantity}
                />
                <img
                  onClick={() => updateQuantity(item._id, item.size, 0)}
                  className="w-4 mr-4 sm:w-5 cursor-pointer"
                  src={images.bin_icon}
                  alt="bin"
                />
              </div>
            </div>
          );
        })}
      </div>

      {/* Bottom */}
      <div className="flex justify-end my-20 lg:px-22">
        <div className="w-full sm:w-[450px] ">
          <CartTotal />

          <div className="w-full text-end ">
            <button
              onClick={() => navigate("/checkout")}
              className="bg-black rounded-full text-white text-sm my-8 px-8 py-3 hover:bg-transparent hover:text-zinc-900 border-2 border-zinc-900 transition2 "
            >
              PROCEED TO CHECKOUT
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartSection;
